module.exports = __webpack_public_path__ + "static/media/action-bar-background.6d6cb3b7.svg";